module.exports = __webpack_public_path__ + "static/media/24UHCHR19.2ad7d7c2.jpg";